import type { AnyAction } from 'redux';
const initialState = {};

const shopConfigReducer = (state = initialState, action: AnyAction) => {
  const { payload, type } = action;
  switch (type) {
    case 'APPLY_WHITE_LABEL_CONFIG':
      return payload.data;
    default:
      return state;
  }
};
export default shopConfigReducer;
